import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { AppleRestrictionsProfilePreset } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const RestrictionsProfileApiActions = createActionGroup({
  source: 'Restrictions profile API',
  events: {
    'Profiles loaded': props<{ profiles: AppleRestrictionsProfilePreset[] }>(),
    'Profiles loaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const RestrictionsProfileResolverActions = createActionGroup({
  source: 'Restrictions profile resolver',
  events: {
    'Profiles requested': emptyProps(),
  },
});
